<template>
  <div class="error__container">
    <div class="error__404">
      <header class="error__header">
        <h1 class="error__heading">404 | We're Sorry</h1>
        <p>
          We can't find the page you're looking for. Please
          <router-link to="/">Return to the homepage</router-link>.
        </p>
      </header>
      <div
        class="error__image-container"
        :class="{ 'error__image-container--loaded': imageLoaded }"
      >
        <div class="error__image">
          <img
            alt=""
            class="error__image-bg"
            src="/images/404-bg.png"
            @load="imageLoaded = true"
          />
          <img
            alt=""
            class="error__image-tumbleweed"
            src="images/404-tumble.svg"
          />
          <!-- <img class="error__image-turtle" src="/images/404-turtle.svg" /> -->
          <svg
            alt=""
            class="error__image-turtle"
            id="Layer_1"
            data-name="Layer 1"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 74.62 32.27"
          >
            <defs>
            </defs>
            <path
              class="cls-1"
              d="M61.42,13.18h0a7.17,7.17,0,0,0-2.06-2.45c-1.32-.92-7.93-2.45-8.66-1s1,1.7,0,3.11a13,13,0,0,1-2.42,2.09.78.78,0,0,0-.14-.53c.16-.42-.45-1.07-1.24-1.28a27.14,27.14,0,0,1-6.77-3C34.69,6.81,24.55,4,15.63,4.54S2.12,8.65.47,12.66c-1.41,3.44,1,4.11-.3,5.15-.43.34,0,1.06.82,1.47l1,.47a1.55,1.55,0,0,0,.74.87,44.91,44.91,0,0,0,5.49,2.9c-1.49,2.9,3.4,8.2,3.4,8.2,1.92.84,5.53.7,6-.27,1.09-.24,1.68-.74,1-1.49a37.87,37.87,0,0,1-3.68-4.31,19.94,19.94,0,0,0,5,.36l23-1.41a3.8,3.8,0,0,0,2.7-2,33.73,33.73,0,0,1,3.91,5.78c1.09,2,7,1.79,7.83.39A2.13,2.13,0,0,0,58.66,28s-4.07-6.94-11.14-9.54a1.65,1.65,0,0,1,.11-.36l.44.13h.08a3.31,3.31,0,0,0,.55.08H50l.55-.07h0l.47-.1h.08A2.8,2.8,0,0,0,51.5,18h.08l.33-.15.4-.24c.4-.26.86-.57,1.47-.9a17.55,17.55,0,0,1,3.55-1.42c.38-.11.72-.23,1-.34l.28-.11.59-.24.25-.11.47-.23.18-.1c.17-.1.33-.19.46-.28h0l.36-.26h0l.09-.07.12-.1h0l.08-.07h0l0-.05Z"
            />
            <path
              class="cls-2 turtle__left-leg"
              d="M21.08,21.83a21.81,21.81,0,0,0,.16,7.43c.34,2-4.72,2.19-6.24.84,0,0-1-7.43,3.54-10.3Z"
            />
            <path
              class="cls-2 turtle__right-leg"
              d="M53.92,20.27a25.15,25.15,0,0,1-.2,8.61c-.39,2.35,5.48,2.54,7.24,1,0,0,1.18-8.61-4.11-11.94Z"
            />
            <path
              class="cls-3"
              d="M13.68,15.78a1.1,1.1,0,0,0-1,1.18,1,1,0,0,0,.17.51c1.67,2.56,5.7,7.36,12.51,7.36H48.39c3.14,0,9.42-7.21,12.2-10.6a1,1,0,0,0-.82-1.58Z"
            />
            <path
              class="cls-4"
              d="M12.4,14.07a1.09,1.09,0,0,0-.47,1.47,1.05,1.05,0,0,0,.2.27c2,2,6.53,5.8,12,5.8,7.32,0,19.29-.71,24.12-.71,3.73,0,9.92-5,12.54-7.3a1,1,0,0,0,0-1.41.88.88,0,0,0-.24-.19,11.82,11.82,0,0,1-4.28-4C53.43,3.9,45.75,0,36.81,0A28.63,28.63,0,0,0,16.44,8.22C12.57,12,14.39,13,12.4,14.07Z"
            />
            <path
              class="cls-2"
              d="M24.14,20c-4.53,0-8.52-3.14-10.39-4.9a3.7,3.7,0,0,0,1.44-2.21,7.51,7.51,0,0,1,2.38-3.58A26.89,26.89,0,0,1,36.82,1.58c8.48,0,15.7,3.79,18.18,7.36a14.17,14.17,0,0,0,4.09,4c-4.63,3.92-8.73,6.33-10.83,6.33s-5.72.14-9.79.31C33.58,19.81,28.14,20,24.14,20Z"
            />
            <path
              class="cls-5 turtle__right-leg"
              d="M52.14,21.05a25.15,25.15,0,0,1-.2,8.61c-.39,2.35,5.48,2.55,7.24,1,0,0,1.18-8.61-4.11-11.93Z"
            />
            <path
              class="cls-5 turtle__left-leg"
              d="M19.42,22.5a21.81,21.81,0,0,0,.17,7.43c.34,2-4.73,2.2-6.25.85,0,0-1-7.43,3.55-10.3Z"
            />
            <path
              class="cls-5"
              d="M57.14,17.08c-.21-1.53,5.43-3.62,7.37-5.16S65,10,66.72,8.37s7,.6,7.57,1.74a5.21,5.21,0,0,1,.2,3A15.38,15.38,0,0,1,69,15.25a31.54,31.54,0,0,0-7,2.55C60.52,18.4,57.3,18.55,57.14,17.08Z"
            />
            <path
              class="cls-6"
              d="M74.26,13.19c-4.55.27-4.82-.51-5.44-.15S62.4,16.9,57.49,17.73c.93.74,3.28.51,4.43,0a31.54,31.54,0,0,1,7-2.55A16.82,16.82,0,0,0,74.26,13.19Z"
            />
            <circle class="cls-7" cx="69.33" cy="10.34" r="0.64" />
            <circle class="cls-6" cx="69.56" cy="10.18" r="0.2" />
            <path
              class="cls-7"
              d="M69.63,13a9.46,9.46,0,0,0,4.05.54,6.1,6.1,0,0,0,.77-.47A22.84,22.84,0,0,1,69.63,13Z"
            />
            <path
              class="cls-8"
              d="M15,12.14s6.39,3.62,8.76,4.11c5.86,1.22,23.23-.71,23.94-.89s8.76-5.18,8.76-5.18"
            />
            <path class="cls-8" d="M17.23,13.8c0,.2-1.41,3.75-1.41,3.75" />
            <line class="cls-8" x1="21.38" y1="15.67" x2="19.71" y2="19.63" />
            <line class="cls-8" x1="25.53" y1="16.48" x2="25.13" y2="20.7" />
            <line class="cls-8" x1="30.63" y1="16.61" x2="30.56" y2="20.36" />
            <line class="cls-8" x1="35.52" y1="16.48" x2="35.52" y2="20.57" />
            <line class="cls-8" x1="40.08" y1="16.21" x2="40.34" y2="20.43" />
            <line class="cls-8" x1="45.23" y1="15.87" x2="45.84" y2="19.96" />
            <line class="cls-8" x1="49.19" y1="14.67" x2="51.26" y2="18.69" />
            <line class="cls-8" x1="52.67" y1="12.46" x2="55.96" y2="16.01" />
            <polyline
              class="cls-8"
              points="20.38 6.09 27.41 8.64 29.22 8.56 41.42 8.03 49.72 3.95"
            />
            <line class="cls-8" x1="41.42" y1="8.03" x2="51.6" y2="12.66" />
            <line class="cls-8" x1="37.46" y1="8.37" x2="36.72" y2="15.94" />
            <line class="cls-8" x1="29.42" y1="8.5" x2="29.42" y2="16.21" />
            <line class="cls-8" x1="24.13" y1="7.36" x2="20.17" y2="14.27" />
            <path class="cls-8" d="M28.14,1.94S30.29,7,42.08,1.67" />
          </svg>
          <img
            alt="Error 404"
            class="error__image-sign"
            src="/images/404-sign.png"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: 'Error',
  components: {},
  data() {
    return {
      imageLoaded: false
    };
  },
};
</script>
<style lang="scss" scoped>
@import '../styles/mixins.scss';
@import '../styles/variables.scss';

$imageWidth: 900px;
$horizontalStep: math.div($imageWidth, 4);
@keyframes tumbleweed {
  0% {
    transform: translate(100%, 0) rotate(0deg);
    opacity: 0;
  }
  8% {
    opacity: 1;
  }
  25% {
    transform: translate(-$horizontalStep * 1, 60px) rotate(-360deg);
  }
  50% {
    transform: translate(-$horizontalStep * 2, 0) rotate(-360deg * 2);
  }
  75% {
    transform: translate(-$horizontalStep * 3, 40px) rotate(-360deg * 3);
  }
  92% {
    opacity: 1;
  }
  100% {
    transform: translate(-$horizontalStep * 4, 0) rotate(-360deg * 4);
    opacity: 0;
  }
}
@keyframes turtle {
  0% {
    transform: translateX(0);
    opacity: 0;
  }
  1% {
    opacity: 1;
  }
  99% {
    opacity: 1;
  }
  100% {
    transform: translateX(810px);
    opacity: 0;
  }
}

@keyframes turtleLeg {
  0% {
    transform: rotate(2deg);
  }
  50% {
    transform: rotate(-2deg);
  }
  100% {
    transform: rotate(2deg);
  }
}
.error {
  &__container {
    margin: $spacing-xxl auto;
    padding: 0 $spacing-md;
    max-width: 960px;
    @include desktop {
      max-width: 1050px;
    }
  }
  &__404 {
    @include tablet-landscape {
      display: flex;
      align-items: center;
    }
  }
  &__header {
    margin: 0 0 $spacing-md;
    @include tablet-landscape {
      flex: 1 0 320px;
      margin: 0 $spacing-lg 0 0;
    }
  }
  &__heading {
    font-family: $font-family-body;
    font-size: pxToRem(36);
    color: $navy;
    font-weight: 600;
    line-height: 1.1;
    font-weight: 600;
    margin-bottom: math.div($spacing-sm, 2);
    @include tablet-landscape {
      margin-bottom: $spacing-sm;
      font-size: pxToRem(54);
    }
  }
  &__image {
    position: relative;
    &-container {
      position: relative;
      left: -200px;
      width: 950px;
      height: 482px;
      opacity: 0;
      transition: opacity 0.15s ease;
      @include tablet-landscape {
        left: 0;
        flex: 0 0 auto;
      }
      &--loaded {
        opacity: 1;
      }
    }
    &-bg {
      position: relative;
      width: 100%;
    }
    &-tumbleweed {
      position: absolute;
      width: 100px;
      right: -$spacing-md;
      bottom: 150px;
      transform: translate(100%, 0);
      animation: tumbleweed infinite 5s linear;
    }
    &-turtle {
      position: absolute;
      bottom: 14%;
      left: 0;
      width: 100px;
      animation: turtle infinite 120s linear;
    }
    &-sign {
      position: absolute;
      width: 200px;
      bottom: 35px;
      left: 135px;
    }
  }
}
.turtle {
  &__right-leg,
  &__left-leg {
    transform-origin: top center;
    animation: turtleLeg infinite 3s linear;
  }
  &__right-leg {
    animation-delay: -1s;
  }
}


//svg styles were erroring out vue
.cls-1,
.cls-7 {
  fill: #013c4d;
}
.cls-1 {
  opacity: 0.17;
  isolation: isolate;
}
.cls-2 {
  fill: #99d9e9;
}
.cls-3 {
  fill: #febf3c;
}
.cls-4 {
  fill: #3cc1cd;
}
.cls-5 {
  fill: #50c6df;
}
.cls-6 {
  fill: #d9eee9;
}
.cls-8 {
  fill: none;
  stroke: #3cc1cd;
  stroke-miterlimit: 10;
  stroke-width: 1.59px;
}
</style>
